import type { OnboardingOfferKey } from "@/services/api-hooks/offers";

import { track } from "../track";
import { buildOfferAnalyticsBaseParams } from "./offerAnalyticsParams";

interface Params {
  offerKey: OnboardingOfferKey;
}

export const trackOfferPopupShown = ({ offerKey }: Params) =>
  track({ event: "offer_popup_shown", ...buildOfferAnalyticsBaseParams(offerKey) });
